import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

// Resuelve /s/:code con la sesión del usuario (mismas reglas de visibilidad que el detalle).
export default function SubastaCorta() {
  const { code } = useParams();
  const nav = useNavigate();
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    api.get(`/auctions/by-code/${encodeURIComponent(code)}`)
      .then((r) => nav(`/subastas/${r.data.id}`, { replace: true }))
      .catch(() => setMissing(true));
  }, [code, nav]);
  return (
    <div className="max-w-md mx-auto px-5 py-24 text-center" data-testid="short-link-page">
      {missing ? (
        <>
          <h1 className="font-display text-3xl mb-3" data-testid="short-link-404">Subasta no encontrada</h1>
          <p className="text-white/60 mb-6">El enlace no existe o la subasta no está disponible.</p>
          <Link to="/subastas" className="sx-btn inline-flex h-12 px-6 items-center">Ver subastas</Link>
        </>
      ) : <p className="text-white/50">Abriendo subasta…</p>}
    </div>
  );
}
